<ng-container *ngIf="theme != 'new'">
<div *ngIf="selected.length; else placeholder">
  <span *ngFor="let item of selected; let last = last">{{item[itemTextField]}} {{last ? "" : ", "}}</span>
</div>
</ng-container>
<ng-container *ngIf="theme == 'new'">
<div *ngIf="selected.length">
  <ion-input style="cursor: pointer;" *ngFor="let item of selected; let last = last" label="Munkavállaló" fill="outline" labelPlacement="stacked" type="text" placeholder="" value='{{item[itemTextField]}} {{last ? "" : ", "}}'></ion-input>
</div>
<div *ngIf="!selected.length">
  <ion-input style="cursor: pointer;" readonly label="Munkavállaló" fill="outline" labelPlacement="stacked" type="text" value='{{placeholderText}}'></ion-input>
</div>
</ng-container>
<ng-template #placeholder>{{placeholderText}}</ng-template>
<ion-modal [isOpen]="isOpen">
  <ng-template>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button (click)="cancel()">Mégse</ion-button>
      </ion-buttons>
      <ion-title>
        {{title}}
      </ion-title>
      <!--ion-buttons slot="end">
        <ion-button (click)="sajat()">Saját adatok</ion-button>
      </ion-buttons-->
    </ion-toolbar>
    <ion-toolbar>
      <ion-searchbar [debounce]="1000" show-cancel-button="never" [placeholder]="placeholderText" (ionChange)="filter($any($event))" ></ion-searchbar>
    </ion-toolbar>
  </ion-header>
    <ion-content>
      <ion-item *ngFor="let item of filtered">
        <ion-checkbox *ngIf="!itemTextField2" labelPlacement="start" [(ngModel)]="item.selected" (ionChange)="itemSelected()">{{item[itemTextField]}}</ion-checkbox>
        <ion-checkbox *ngIf="itemTextField2" labelPlacement="start" [(ngModel)]="item.selected" (ionChange)="itemSelected()">{{item[itemTextField]}} {{item[itemTextField2]}}</ion-checkbox>
      </ion-item>
    </ion-content>
  </ng-template>
</ion-modal>
